import {
  MdOutlineApartment,
  MdOutlineDashboard,
  MdOutlineGavel,
} from "react-icons/md";

export default function BankLinks() {
  const bankSidebarLinks = [
    {
      name_en: "Bank Dashboard",
      name_ar: "لوحة تحكم البنك",
      href: "/bank/dashboard",
      icon: MdOutlineDashboard,
    },

    {
      name_en: "My Bank Details",
      name_ar: "بيانات البنك",
      icon: MdOutlineApartment,
      subMenu: [
        {
          name_en: "Edit Details",
          name_ar: "تعديل البيانات",
          href: "/bank/details/edit",
        },
        {
          name_ar: "برامج التمويل ",
          name_en: "Mortgage Programs",
          href: "/bank/mortgage-programs",
        },
        {
          name_ar: "جميع طلبات التمويل",
          name_en: "Mortgage Applications",
          href: "/bank/mortgage-applications",
        },
        {
          name_ar: "المبالغ المستحقة",
          name_en: "Outstanding Amounts",
          href: "/bank/payables",
        },
      ],
    },

    // {
    //   name_en: "Subscriptions",
    //   name_ar: "الاشتراكات",
    //   icon: MdOutlineSubscriptions,
    //   subMenu: [
    //     {
    //       name_en: "My Subscription",
    //       name_ar: "اشتراكي",
    //       href: "/bank/subscription/my",
    //     },
    //     {
    //       name_en: "Subscription Plans",
    //       name_ar: "خطط الاشتراك",
    //       href: "/bank/subscription/plans",
    //     },
    //     {
    //       name_en: "Payment History",
    //       name_ar: "سجل المدفوعات",
    //       href: "/bank/subscription/payments",
    //     },
    //   ],
    // },

    {
      name_en: "Auctions",
      name_ar: "المزادات",
      icon: MdOutlineGavel,
      subMenu: [
        {
          name_en: "My Auctions",
          name_ar: "مزاداتي",
          href: "/bank/auctions/my",
        },
        {
          name_en: "Join Auction",
          name_ar: "انشر مزادك",
          href: "/bank/auctions/join",
        },
      ],
    },
  ];

  return bankSidebarLinks;
}
